import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { ProductVariantDto } from './ProductVariantDto'
/**
* Class ProductVariantsDto
*  Информация о вариантах продукта, если они есть<br>
*/
export class ProductVariantsDto extends ActiveModel {

  /**
  * keyWithValues
  * Все ключевые атрибуты со всеми их возможными значениями, под которые существуют варианты, где: <br><br>ключ: идентификатор ключевого атрибута; <br><br>значение: список значений, которые есть у вариантов<br>  */
  @ActiveField(() => ({}))
  keyWithValues: Record<string, object> = {}


  /**
  * selfVariant
  * Информация о текущем продукте в виде варианта<br>  */
  @ActiveField({
    factory: [ProductVariantDto, () => ProductVariantDto.create()]
  })
  selfVariant: ProductVariantDto = ProductVariantDto.create()


/**
  * @property variants
  * Все варианты продукта (включая текущий вариант)<br>  */
  @ActiveField({
    factory: [ProductVariantDto, () => []]
  })
  variants: Array<ProductVariantDto> = []
}
